import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  copyArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-rentals-link-accessories-products',
  templateUrl: './rentals-link-accessories-products.component.html',
  styleUrls: ['./rentals-link-accessories-products.component.scss'],
})
export class RentalsLinkAccessoriesProductsComponent implements OnInit {
  public partner: any = {};
  public accessories: any = [];
  public products: any = [];
  public productCategories: any = [];
  public loadingAccessories: boolean = false;
  public updatingAccessories: boolean = false;
  public loadingProducts: boolean = false;
  public connectedAccessories: any = [];

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getLinkedAccessoriesProducts();
    this.getRentalProducts();
  }

  getLinkedAccessoriesProducts() {
    this.loadingAccessories = true;
    this.rentalsService
      .getRentalAccessoryProductLink(this.partner.ID)
      .subscribe(
        (res) => {
          res.forEach((item) => {
            item.linkedProducts = item.linkedProducts || [];
          });
          this.connectedAccessories = res.map((x) => {
            return x.brand + '_' + x.name;
          });
          this.accessories = res;
          this.loadingAccessories = false;
        },
        (err) => {
          this.loadingAccessories = false;
        },
      );
  }

  getRentalProducts() {
    this.loadingProducts = true;
    this.rentalsService.getRentalProducts(this.partner.ID).subscribe(
      (res) => {
        this.products = res
          .map((x) => {
            return {
              brand: x.brand,
              model: x.model,
              imageURL: x.rentalProducts[0].imageURL,
              categoryID: x.categoryID,
              categoryName: x.categoryName,
            };
          })
          .sort((x, y) => {
            if (x.categoryName < y.categoryName) return -1;
            if (x.categoryName > y.categoryName) return 1;
            return 0;
          });
        this.productCategories = [];
        this.products
          .map((x) => {
            return x.categoryName;
          })
          .forEach((x) => {
            if (
              this.productCategories.findIndex((y) => {
                return y.categoryName === x;
              }) === -1
            ) {
              this.productCategories.push({ categoryName: x });
            }
          });
        this.productCategories.forEach((category) => {
          category.products = this.products.filter((x) => {
            return x.categoryName === category.categoryName;
          });
        });
        console.log(this.productCategories);

        this.loadingProducts = false;
      },
      (err) => {
        this.loadingProducts = false;
      },
    );
  }

  noReturnPredicate() {
    console.log('noReturnPredicate');
    return false;
  }

  dropProduct(event) {
    console.log(event);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  dropAccessory(event, accessory) {
    var containsProduct = false;
    event.container.data.forEach((x) => {
      if (
        x.brand === event.previousContainer.data[event.previousIndex].brand &&
        x.model === event.previousContainer.data[event.previousIndex].model
      ) {
        containsProduct = true;
      }
    });

    if (!containsProduct) {
      copyArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.container.data.length,
      );

      var data = {
        ...accessory,
        linkedProduct: {
          ...event.previousContainer.data[event.previousIndex],
        },
      };

      this.rentalsService
        .addRentalAccessoryProductLink(this.partner.ID, data)
        .subscribe(
          (res) => {
            // res.forEach(item=>{
            //   item.linkedProducts = item.linkedProducts || [];
            // });
            // this.accessories = res;
          },
          (err) => {
            this.getLinkedAccessoriesProducts();
          },
        );
    }
  }

  removeProduct(accessory, product) {
    var data = {
      ...accessory,
      linkedProduct: {
        ...product,
      },
    };
    this.rentalsService
      .deleteRentalAccessoryProductLink(this.partner.ID, data)
      .subscribe((res) => {});

    this.accessories.forEach((x) => {
      if (accessory.brand === x.brand && accessory.name === x.name) {
        var index = x.linkedProducts.findIndex((y) => {
          return y.brand === product.brand && y.model === product.model;
        });
        console.log(index);
        if (index > -1) {
          x.linkedProducts.splice(index, 1);
        }
      }
    });
  }

  linkAllProducts(accessory, index) {
    this.accessories[index].linkingProducts = true;
    var data = {
      ...accessory,
      linkedProducts: [],
    };
    this.products.forEach((product) => {
      data.linkedProducts.push(product);
    });
    this.rentalsService
      .addRentalAccessoryProductLink(this.partner.ID, data)
      .subscribe(
        (res) => {
          res.forEach((item) => {
            item.linkedProducts = item.linkedProducts || [];
          });
          this.accessories = res;
        },
        (err) => {
          this.getLinkedAccessoriesProducts();
        },
      );
  }

  linkCategory(accessory, index, category) {
    this.accessories[index].linkingProducts = true;
    var data = {
      ...accessory,
      linkedProducts: [],
    };
    this.products.forEach((product) => {
      if (product.categoryName === category) {
        data.linkedProducts.push(product);
      }
    });
    this.rentalsService
      .addRentalAccessoryProductLink(this.partner.ID, data)
      .subscribe(
        (res) => {
          res.forEach((item) => {
            item.linkedProducts = item.linkedProducts || [];
          });
          this.accessories = res;
        },
        (err) => {
          this.getLinkedAccessoriesProducts();
        },
      );
  }
}
